import {
  globalGetService,
  globalPostService,
  globalPutService,
} from '@/utils/globalApiServices';
import {
  CampaignBuilderMetadata,
  CampaignBuilderMetadataParams,
  CampaignBuilderResult,
} from '@/apis/core/types';

export const getCampaignBuilderMetadata = async (
  brandUid: string,
  params: CampaignBuilderMetadataParams = {},
  configs: Record<string, any> = {}
) => {
  const response = await globalGetService(
    `csp/campaign/builder/brand/${brandUid}`,
    params,
    configs
  );
  return (response?.ok ? response.data : []) as CampaignBuilderMetadata[];
};

export const createCampaign = async (
  brandUid: string,
  useCaseId: string,
  cnpUid: string,
  data: Record<string, any>
) => {
  const response = await globalPostService(
    `csp/campaign/builder/brand/${brandUid}/usecase/${useCaseId}`,
    data
  );
  const campaign = response?.ok
    ? (response.data as CampaignBuilderResult)
    : undefined;
  if (campaign) {
    await globalPutService(
      `csp/campaigns/sharedByMe/${campaign.campaignUid}/with/${cnpUid}`
    );
  }
  return campaign;
};
